import { Component, ComponentInterface, h, Prop, Watch } from '@stencil/core';

export interface UiCmsFootnoteListBody {
  isIndexDisplayed?: boolean;
  startingIndex?: number;
  footnotes: Footnote[];
}

interface Footnote {
  text: string;
}

@Component({
  tag: 'ui-cms-footnote-list',
  styleUrl: 'ui-cms-footnote-list.scss',
})
export class UiCmsFootnoteList implements ComponentInterface {
  @Prop({ mutable: true }) body: UiCmsFootnoteListBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Prop() inverted: boolean;

  @Watch('utilityBody')
  bodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  componentWillLoad() {
    this.bodyChangeHandler(this.utilityBody);
  }

  render() {
    const { footnotes, startingIndex, isIndexDisplayed } = this.body;

    return isIndexDisplayed ? (
      <ol
        start={startingIndex || 1}
        class={{ 'sd-footnotes': true, 'sd-footnotes--inverted': this.inverted }}
        role="contentinfo"
        aria-label="Footnotes"
      >
        {footnotes?.map((footnote, idx) => <li key={idx}>{footnote.text}</li>)}
      </ol>
    ) : (
      <ul
        class={{ 'sd-footnotes': true, 'sd-footnotes--inverted': this.inverted }}
        role="contentinfo"
        aria-label="Footnotes"
      >
        {footnotes?.map((footnote, idx) => <li key={idx}>{footnote.text}</li>)}
      </ul>
    );
  }
}
